import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  homeLinks: [],
  status: "idle",
  error: null,
};

export const homelLinksByCountrySlice = createSlice({
  name: "homelLinks",
  initialState,
  reducers: {
    homeLinksRequested: (state) => {
      state.status = "loading";
    },
    homeLinksRequestFailed: (state, action) => {
      state.status = "failed";
      state.error = action.payload;
    },
    homeLinksRequestSucceeded: (state, action) => {
      state.status = "succeeded";
      state.homeLinks = action.payload;
    },
  },
});

export const {
  homeLinksRequested,
  homeLinksRequestFailed,
  homeLinksRequestSucceeded,
} = homelLinksByCountrySlice.actions;

export default homelLinksByCountrySlice.reducer;
